import { Button } from "./button";

type MultiSelectTagsProps = {
  id?: string;
  values: string[];
  options: string[];
  onChange: (next: string[]) => void;
  emptyLabel?: string;
  disabled?: boolean;
};

function unique(values: string[]) {
  return [...new Set(values)];
}

function toggle(values: string[], value: string) {
  if (values.includes(value)) {
    return values.filter((item) => item !== value);
  }
  return [...values, value];
}

export function MultiSelectTags({
  id,
  values,
  options,
  onChange,
  emptyLabel = "No items selected.",
  disabled = false,
}: MultiSelectTagsProps) {
  const selected = unique(values.filter((value) => value.trim().length > 0));
  const available = unique(
    options.filter((value) => value.trim().length > 0 && !selected.includes(value))
  );

  return (
    <div id={id} className="cf-tag-select">
      <div className="cf-tag-select-selected">
        {selected.length === 0 ? <p className="cf-help">{emptyLabel}</p> : null}
        {selected.map((value) => (
          <Button
            key={`selected-${value}`}
            type="button"
            size="sm"
            variant="solid"
            tone="neutral"
            style={{
              border: "1px solid var(--cf-yellow)",
              color: "var(--cf-text)",
            }}
            disabled={disabled}
            onClick={() => onChange(selected.filter((item) => item !== value))}
          >
            {value} ×
          </Button>
        ))}
      </div>
      <div className="cf-tag-select-options">
        {available.map((value) => (
          <Button
            key={`option-${value}`}
            type="button"
            size="sm"
            variant={selected.includes(value) ? "solid" : "outline"}
            tone={selected.includes(value) ? "brand" : "neutral"}
            disabled={disabled}
            aria-pressed={selected.includes(value)}
            onClick={() => onChange(toggle(selected, value))}
          >
            {value}
          </Button>
        ))}
      </div>
    </div>
  );
}
